import useAuth from './auth/useAuth.js';
import CustomButton from './CustomButton.js';
import Moment from 'react-moment';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Typography, Button, Grid, Chip, Card, CardActions, CardMedia, CardContent, CircularProgress, Backdrop } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';
import { Helmet } from "react-helmet";
import { UserJourneyServices, ModuleCompletionServices, RefreshRequestServices } from './Services.js';
import { CheckRounded } from '@material-ui/icons';
import RotateLeftRoundedIcon from '@material-ui/icons/RotateLeftRounded';
import WatchLaterRoundedIcon from '@material-ui/icons/WatchLaterRounded';
import HourglassFullRoundedIcon from '@material-ui/icons/HourglassFullRounded';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const tileStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        border: "1px solid " + theme.palette.grey.main,
        position: 'relative',
        borderRadius: '0',
        height: "100%"
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1'
    },
    title: {
        fontFamily: theme.fontFamily1
    },
    grid: {
        marginTop: theme.spacing(2)
    },
    cover: {
        width: "40%",
        flexShrink: 0
    },
    chip: {
        position: 'absolute',
        bottom: theme.spacing(1),
        left: theme.spacing(1),
        borderRadius: "0",
        background: "#FFF",
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        fontWeight: "bold",
        maxWidth: 100,
        fontSize: "0.9rem",
        height: "auto",
        "& .MuiChip-label": {
            whiteSpace: "normal",
            textOverflow: "unset"
        }

    },
    completedChip: {
        borderRadius: "0",
        background: "#FFF",
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        fontWeight: "bold",
        fontSize: "0.9rem",
        height: "auto",
        "& .MuiChip-label": {
            [theme.breakpoints.down('md')]: {
                padding: 0
            },
            whiteSpace: "normal",
            textOverflow: "unset"
        },
        "& .MuiChip-avatar": {
            color: theme.palette.primary.dark,
            background: 'transparent',
            [theme.breakpoints.down('md')]: {
                display: 'none'
            },           
        },
    },
    chipRefresh: {
        flexShrink:"0",
        borderRadius: "0",
        background: "#FFF",
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        fontWeight: "bold",
        fontSize: "0.9rem",
        height: "auto",
        "& .MuiChip-label": {
            [theme.breakpoints.down('md')]: {
                padding: 0
            },
            whiteSpace: "normal",
            textOverflow: "unset",
        },
        "& .MuiChip-avatar": {
            color: theme.palette.primary.dark,
            background: 'transparent',
            [theme.breakpoints.down('md')]: {
                display: 'none'
            },
        },
        "& .MuiChip-avatarSmall": {

        }
    },
    chipDuration: {
        position: 'absolute',
        top: theme.spacing(1),
        left: theme.spacing(0),
        borderRadius: "0",
        background: "#FFF",
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        fontWeight: "bold",
        maxWidth: 150,
        fontSize: "0.8rem",
        height: "auto",
        "& .MuiChip-label": {
            whiteSpace: "normal",
            textOverflow: "unset"
        },
        "& .MuiChip-avatar": {
            color: theme.palette.primary.dark,
            background: 'transparent',           
        },
    },
    content: {
        flex: '1 0 auto',
        paddingTop: 0
    },
    actions: {
        paddingBottom: theme.spacing(2),
        paddingLeft: 0,
        justifyContent: "flex-end",


    },
    desc: {
        fontSize: "0.9rem",
        lineHeight: "1.3rem"
    },
    startButton: {

    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#ffffffaa'
    },
}));
const ModuleTile = ({ title, image, description, url, alt, allStaff, completion, refreshCycle, refreshRequest, onSelfReset, estimate }) => {
    let auth = useAuth();
    const classes = tileStyles();
    const [startButtonText, setStartButtonText] = useState("Start module");
    const [actualUrl, setActualUrl] = useState(url);
    const [refreshRequired, setRefreshRequired] = useState(false);
    const [refreshDue, setRefreshDue] = useState(null);
    const [lastJourney, setLastJourney] = useState(null);

    const login = () => { auth.signin(); };

    useEffect(() => {   
        if (completion == null) {
            if (lastJourney == null) {
                // first time, never done this module before
                // start button
                setActualUrl(url);
                setStartButtonText("Start module");
      
            } else {
                // has started but not yet completed
                //continue button
                setActualUrl(url + "/" + (lastJourney.branchURL != null ? lastJourney.branchURL : ""));
                setStartButtonText("Continue module");

            }
        }
        else {
            if (lastJourney != null) {
                //console.log(refreshRequired);
                if (refreshRequired) {
                    //console.log(url + " refresh due: " + refreshDue);
                    //console.log(url + " lastvisited: " + moment.utc(lastJourney.visitedDateTime).toDate());
                    // need to be in moment format as refreshDue is calculated in moment
                    if (moment.utc(lastJourney.visitedDateTime).toDate()  > refreshDue) {
                        // need refresh and has started but not yet completed the refresh
                        // continue
                        setActualUrl(url + "/" + (lastJourney.branchURL != null ? lastJourney.branchURL : "") );
                        setStartButtonText("Continue module");
                    } else {
                        // need refresh but hasn't started 
                        // start
                        setActualUrl(url);
                        setStartButtonText("Start module");
                    }
                }
                else {
                    if (lastJourney.visitedDateTime > completion) {
                        // completed, don't need refresh, but has gone back in after completing, so need to remember where the user was  last
                        // review
                        setActualUrl(url + "/" + (lastJourney.branchURL != null ? lastJourney.branchURL : ""));
                        setStartButtonText("Review module");
                    } else {
                       // completed, don't need refresh, and hasn't gone back in since, show restart button in case users want to restart at their own will
                        // review
                        setActualUrl(url);
                        setStartButtonText("Review module");
                    }
                }
            }
        }
        
       
    }, [refreshRequired, refreshDue, lastJourney, completion]);
    useEffect(() => {
        if (refreshCycle != null) {
            if (completion != null) {
                var daylapse = moment.utc(new Date()).diff(moment.utc(completion), 'days');
                //console.log("daylapse:" + daylapse);
                //console.log("utc time: " + moment().utc().format());
                if (daylapse < refreshCycle) {
                    setRefreshRequired(false);
                } else {
                    setRefreshDue(moment.utc(completion).add(refreshCycle, 'd').toDate());
                    //console.log(url + " refresh due date set by cycle");
                    setRefreshRequired(true);

                }
            } else {
                // this is the first time user doing this module
                setRefreshRequired(false);
            }
        } else {
            setRefreshRequired(false);
        }
        //check for one-off refresh request
        if (refreshRequest != null) {
            if (completion != null) {
                //console.log(url + " refresh request: " + refreshRequest);
                //console.log(url + " completion: " + completion);
                if (refreshRequest > completion) {
                    setRefreshRequired(true);
                    setRefreshDue(moment.utc(refreshRequest).toDate());
                    //console.log(url + " refresh due date set by request");
    
                }
            }
        }
    }, [refreshCycle, completion, refreshRequest]);

    //user has visited a page in the module, grab the last journey
    useEffect(() => {
        UserJourneyServices.get(url).then(response => {
            if (response.data) {
                setLastJourney(response.data);
            }
        });

        //var previous = localStorage.getItem("eo_progress_" + url);
        //var prevDate = localStorage.getItem("eo_progress_date_" + url);
        //if (previous && prevDate) {
        //    var progressDate = new Date(parseInt(prevDate));
        //    var diffDays = Math.round(Math.abs(((new Date()) - progressDate) / (24 * 60 * 60 * 1000)));
        //    if (diffDays < 30) {
        //        setActualUrl(url + "/" + previous);
        //        setCont(true);
        //    }
        //}
    }, [url]);
    return (
        <Card className={classes.root} elevation={0}>
            {image ? <CardMedia className={classes.cover} image={image} title={alt} /> : null}
            <div className={classes.details}>
                <CardContent className={classes.content}>
                    {title ? <Typography gutterBottom variant="h3" component="h3" className={classes.title}>{title}</Typography> : null}
                    <Chip label={allStaff ? "all staff" : "managers & team leaders"} color="secondary" className={classes.chip} />
      
                    <Typography variant="body1" color="textPrimary" component="p" className={classes.desc}>{description}</Typography>
                  
       
                    {!auth.user && auth.canLogin() ? null :
                                <>
                            {completion != null ?
                                <>
                                    {refreshRequired ?
                                        <Tooltip
                            title="You are required to refresh this module"
                                            aria-label="You are required to refresh this module"><Chip color="secondary" className={classes.chipRefresh} size="small" label={"Due for refresh"} avatar={<WatchLaterRoundedIcon />} /></Tooltip> :
                                        <Chip color="secondary" className={classes.completedChip} size="small"
                                            label={"Completed on " + moment.utc(completion).local().format('D/MM/YYYY h:mm a')} avatar={<CheckRounded />} />}
                                    </> 
                                : null}
                           
                        </>
                           
                    }
                </CardContent>
                <CardActions className={classes.actions}>
                   
                    {!auth.user && auth.canLogin() ?
                        <CustomButton variant="contained" color="primary" onClick={login} aria-label="open login page">Login to access</CustomButton> :
                        <>{auth.allowSelfReset && !refreshRequired && completion != null ? <Tooltip
                            title="Self-reset my progress to allow module refresh"
                            aria-label="Self-reset my progress to allow module refresh"><IconButton color="primary" aria-label="Self-reset my progress to allow module refresh" onClick={onSelfReset}>
                            <RotateLeftRoundedIcon />
                            </IconButton></Tooltip> : null}<CustomButton variant="contained" color="primary" className={classes.startButton} component={Link} to={actualUrl}>{startButtonText}</CustomButton>

                                          <Tooltip
                        title={"We expect this module will take around " +  estimate  + " to complete"}
                                aria-label={"We expect this module will take around " + estimate + " to complete"}><Chip color="secondary" className={classes.chipDuration} size="small" label={estimate} /></Tooltip>
                        </>
                    }
            
                </CardActions>
            </div>
        </Card>
    );
};


const Home = () => {
    const classes = tileStyles();
    // flag to prevent homepage to flash before redirect
    const [okToLoad, setOKToLoad] = useState(false);
    const [completions, setCompletions] = useState([]);
    const [refreshRequest, setRefreshRequest] = useState([null, null, null, null]);
    const [completionTimes, setCompletionTimes] = useState([null, null, null, null]);
    const [loading, setLoading] = useState(false);//don't let user click when calling api

    let auth = useAuth();
    useEffect(() => {   
        // send those who came here from path that's not '/' to where they were
        if (sessionStorage.getItem("redirectPath") && sessionStorage.getItem("redirectPath") != "/") {          
                var goto = sessionStorage.getItem("redirectPath");
                sessionStorage.removeItem("redirectPath");
            window.location = process.env.PUBLIC_URL + goto;
   
        } else { setOKToLoad(true); }
        setLoading(true);
        ModuleCompletionServices.getLast().then(response => {
            setCompletions(response.data);
            var arr = [null, null, null, null];
            response.data.forEach((i) => {
                arr[i.moduleID - 1] = i.completionDateTime;
            });
            setCompletionTimes(arr);
            setLoading(false);
        });
        setLoading(true);
        loadRefresRequests();

    }, []);
    const loadRefresRequests = () => {

        RefreshRequestServices.getLast().then(response => {
            var arr = [null, null, null, null];
            response.data.forEach((i) => {
                arr[i.moduleID - 1] = i.refreshRequestDate;
            });
            setRefreshRequest(arr);
            setLoading(false);
        });
    }
    const selfReset = (moduleID) => {
        setLoading(true);
        RefreshRequestServices.create({ moduleID: moduleID, userID: auth.user.id}).then((response) => {
            loadRefresRequests(); 
        });
    }
    return (
        <React.Fragment>
            {okToLoad ?
                <div>

                    <Helmet>
                        <title>Equal Opportunity Online</title>
                    </Helmet>
                    <Typography variant="h1" style={{ marginBottom: "0.5rem" }}>Equal Opportunity Online</Typography>
                    <Typography variant="subtitle1" component="p">Diversity and Inclusion for All</Typography>
                    <Typography variant="body1" component="p">Welcome! Thanks for taking the time to engage with this important program.
                        Our hope is that in completing these modules you will discover the rich
                        benefits that flow to us as we pursue our objectives of being a diverse
                        and inclusive workplace.</Typography>
                    <Typography variant="body1" component="p"><b>This starts with you.</b> You belong here. Diversity and inclusion
                        acknowledges the unique combination of attributes that make up who
                        you are and the value that your lived experiences bring to our
                        University. Thanks for being you!</Typography>
                    <Typography variant="body1" component="p"><b>This is also about us.</b> It's about the things we do and say,
                        and the policies and procedures that we implement to send the right messages
                        every day to our colleagues that "you belong here too!"</Typography>
                    <Typography variant="body1" component="p">By completing this program, you will:</Typography>
                    <ul>
                        <Typography variant="body2" component="li">understand the importance and value of a diverse and inclusive workplace;</Typography>
                        <Typography variant="body2" component="li">know your Equal Employment Opportunity (EEO) rights and responsibilities;</Typography>
                        <Typography variant="body2" component="li">identify different forms of discrimination including practical prevention strategies;</Typography>
                        <Typography variant="body2" component="li">understand the importance of positive workplace relationships; and</Typography>
                        <Typography variant="body2" component="li">understand the critical role that managers and leaders play through intentional inclusion.</Typography>
                    </ul>

                    <Typography variant="h2">Program Overview</Typography>
                    <Typography variant="body1" component="p">The program is divided into 4 modules.</Typography>
                    <ul>
                        <Typography variant="body2" component="li">All staff members need to complete Modules 1 to 3.</Typography>
                        <Typography variant="body2" component="li">Module 4 is for Managers and Team Leaders (although staff without supervisory responsibility are welcome to complete it).</Typography>
                    </ul>

                    <Grid container spacing={4} direction="row" justifyContent="flex-start" alignItems="stretch" className={classes.grid}>
                        <Grid item xs={12} sm={12} md={6}>
                            <ModuleTile allStaff
                                title="Module 1: Diversity and Inclusion on Campus"
                                image="images/home/splash_1.jpg"
                                description="Provides an overview of Equal Employment Opportunity (EEO) principles including your rights and responsibilities and special measures that apply to members of EEO 'target groups'."
                                estimate="10 to 25 minutes"
                                completion={completionTimes[0]} refreshCycle={auth.refreshCycles[0]} refreshRequest={refreshRequest[0]}
                                url="diversity" alt="" onSelfReset={() => selfReset(1)} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <ModuleTile allStaff
                                title="Module 2: Preventing Discrimination at Work"
                                image="images/home/splash_2.jpg"
                                description="Explores our shared responsibilities to eliminate both direct and indirect discrimination in the workplace including examples and cases studies of different categories of discrimination."
                                estimate="25 to 30 minutes"
                                completion={completionTimes[1]} refreshCycle={auth.refreshCycles[1]} refreshRequest={refreshRequest[1]}
                                url="discrimination" alt="" onSelfReset={() => selfReset(2)} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <ModuleTile allStaff
                                title="Module 3: Workplace Relationships"
                                image="images/home/splash_3.jpg"
                                description="Examines some of the issues which can erode positive workplace relationships such as bullying and harassment, and inappropriate relationships.  "
                                estimate="25 to 30 minutes"
                                completion={completionTimes[2]} refreshCycle={auth.refreshCycles[2]} refreshRequest={refreshRequest[2]}
                                url="relationships" alt="" onSelfReset={() => selfReset(3)} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <ModuleTile
                                title="Module 4: Intentional Inclusion"
                                image="images/home/splash_4.jpg"
                                description="Encourages those in supervisory roles to be proactive in building inclusive teams as well as how to manage issues that might arise. "
                                estimate="30 to 35 minutes"
                                completion={completionTimes[3]} refreshCycle={auth.refreshCycles[3]} refreshRequest={refreshRequest[3]}
                                url="inclusion" alt="" onSelfReset={() => selfReset(4)} />
                        </Grid>
                    </Grid>
                </div> :

            
                    <CircularProgress />
            }
            <Backdrop open={loading} className={classes.backdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            </React.Fragment>
    );
};

export default Home;
